import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as employeeApi from '../Api/employeeApi';

const EMPLOYEE_KEY = 'employees';

export const useEmployees = (options = {}) => {
	const query = useQuery({
		queryKey: [EMPLOYEE_KEY],
		queryFn: async () => {
			const res = await employeeApi.getEmployees();
			return res.data;
		},
		enabled: options.enabled !== false,
		...options,
	});
	return { ...query, data: Array.isArray(query.data) ? query.data : [] };
};

export const useEmployee = (id) =>
	useQuery({
		queryKey: [EMPLOYEE_KEY, id],
		queryFn: async () => {
			const res = await employeeApi.getEmployeeById(id);
			// Always return the employee object at the root for consumers
			return res.data.employee || res.data;
		},
		enabled: !!id,
	});

export const useCreateEmployee = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: employeeApi.createEmployee,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMPLOYEE_KEY] });
		},
	});
};

export const useUpdateEmployee = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, data }) => employeeApi.updateEmployee(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMPLOYEE_KEY] });
		},
	});
};

export const useUpdateEmployeeProfileImage = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, profileImage }) =>
			employeeApi.updateEmployeeProfileImage(id, profileImage),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMPLOYEE_KEY] });
		},
	});
};

export const useDeleteEmployee = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id) => employeeApi.deleteEmployee(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMPLOYEE_KEY] });
		},
	});
};

export const useResendEmployeePassword = () => {
	return useMutation({
		mutationFn: (id) => employeeApi.resendEmployeePassword(id),
	});
};
